import React, { useEffect, useState } from 'react'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import { trackingGAEventProdotto } from '../../../../../utils/gtm'
import { useDuplicaPersonalizzazione } from '../../../DuplicaPersonalizzazione/DuplicaPersonalizzazione'
import useTrans from '../../../../../hooks/useTrans'

const NomeLavorazione = ({ setStep, step, props, obj }) => {
  const t = useTrans()
  const [NomeLavorazione, setNomeLavorazione] = useState(props.values.nome_lavorazione || '')
  const [pDisponibili, setpDisponibili] = useState([])
  const { checkPersonalizzazioniDisponibili } = useDuplicaPersonalizzazione()

  const handleNome = (obj, personalizzazioniDisponibili) => {
    if (
      personalizzazioniDisponibili?.filter((item) => item?.nome_lavorazione === obj)?.length > 0
    ) {
      const nome = obj?.toString().split('_')
      const numero_max = personalizzazioniDisponibili
        ?.filter((item) => item?.nome_lavorazione?.split('_')[0] === nome[0])
        ?.reduce(
          (prev, curr) => {
            const value = curr?.nome_lavorazione?.split('_')[1] || 0
            return Math.max(prev, parseInt(value))
          },
          [0]
        )
      const new_nome = nome?.[0] + '_' + (parseInt(numero_max) + 1)
      return new_nome
    }
    return obj
  }
  useEffect(async () => {
    const result = await checkPersonalizzazioniDisponibili(
      props?.values?.prodotto?.id || obj?.prodotto_id
    ).catch((err) => console.log(err))
    setpDisponibili(result)
  }, [])

  useEffect(() => console.log(), [NomeLavorazione])

  return (
    <div className="nomelavorazione">
      <FormField
        size="md"
        label={t('Lavorazione di stampa')}
        status={
          props.errors.nome_lavorazione
            ? 'error'
            : props.touched.nome_lavorazione
            ? 'success'
            : null
        }
        errorMessage={props.errors?.nome_lavorazione}
      >
        <FormInput
          value={NomeLavorazione}
          onBlur={props.handleBlur('nome_lavorazione')}
          placeholder={t('Assegna un nome alla lavorazione di stampa')}
          onChange={(e) => {
            setNomeLavorazione(e.target.value),
              props.setFieldValue('nome_lavorazione', e.target.value)
          }}
        />
      </FormField>
      {
        <Button
          variant="primary"
          size="medium"
          label={t('Salva lavorazione')}
          disabled={props.errors.nome_lavorazione ? true : false}
          onClick={() => {
            props.setFieldValue('nome_lavorazione', handleNome(NomeLavorazione, pDisponibili))
            setStep(step + 1)
            const first_articolo =
              props?.values?.prodotto?.articoli.length > 0
                ? props?.values?.prodotto?.articoli[0]
                : null
            trackingGAEventProdotto(
              'customization_funnel',
              'c_step5_nome_logo',
              undefined,
              first_articolo?.titolo || '',
              props?.values?.prodotto?.codice || ''
            )
          }}
        />
      }
    </div>
  )
}

export default NomeLavorazione
